import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatProgressBarModule, MatProgressSpinnerModule, MatRippleModule, MatTabsModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { DisclaimerModule } from '../../../../core/components/disclaimer/disclaimer.module';
import { FcOutlinedInputModule } from '../../../../core/components/fc-input/base/fc-outlined-input/fc-outlined-input.module';
import { FcOutlinedTextareaModule } from '../../../../core/components/fc-input/base/fc-outlined-textarea/fc-outlined-textarea.module';
import { FcTextInputModule } from '../../../../core/components/fc-input/base/fc-text-input/fc-text-input.module';
import { FcLocationInputModule } from '../../../../core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { DirectivesModule } from '../../../../core/directives/directives.module';
import { DialogLocationSectorComponent } from './dialog-location-sector.component';
import { TabGeneralComponent } from './tabs/general/tab-general.component';
import { TabMaintenancesService } from './tabs/maintenances/services/tab-maintenances.service';
import { TabMaintenancesComponent } from './tabs/maintenances/tab-maintenances.component';

@NgModule({
  entryComponents: [
    DialogLocationSectorComponent,
  ],
  declarations: [
    TabGeneralComponent,
    TabMaintenancesComponent,
    DialogLocationSectorComponent,
  ],
  imports: [
    NgxMaskModule.forRoot(),
    TranslateModule,
    FuseSharedModule,
    MatTabsModule,
    MatRippleModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatDialogModule,
    DisclaimerModule,
    DirectivesModule,
    FcTextInputModule,
    FcOutlinedInputModule,
    FcLocationInputModule,
    FcOutlinedTextareaModule,
    MatDialogModule
  ],
  exports: [
    DialogLocationSectorComponent
  ],
  providers: [
    TabMaintenancesService
  ],
})
export class DialogLocationSectorModule {}
